import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const PetLoader = ({ isVisible, message = "Loading..." }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.4 } }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center"
          style={{ backgroundColor: "rgba(255, 252, 249, 0.92)", backdropFilter: "blur(12px)" }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.97 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="flex flex-col items-center gap-6"
          >
            {/* Paw animation cluster */}
            <div className="relative w-24 h-24">
              {/* Spinning ring */}
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
                className="absolute inset-0 rounded-full"
                style={{
                  border: "3px solid transparent",
                  borderTopColor: "#967d6c",
                  borderRightColor: "#bda697",
                }}
              />
              <motion.div
                animate={{ rotate: -360 }}
                transition={{ duration: 3.5, repeat: Infinity, ease: "linear" }}
                className="absolute inset-2 rounded-full"
                style={{
                  border: "2px solid transparent",
                  borderBottomColor: "#c9b09f",
                  borderLeftColor: "#967d6c",
                  opacity: 0.5,
                }}
              />

              {/* Center paw icon */}
              <motion.div
                animate={{ scale: [1, 1.12, 1] }}
                transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute inset-0 flex items-center justify-center"
              >
                <i
                  className="fa fa-paw"
                  style={{ fontSize: "2rem", color: "#967d6c" }}
                />
              </motion.div>
            </div>

            {/* Floating paw dots */}
            <div className="flex gap-2 items-end">
              {[0, 1, 2].map((i) => (
                <motion.i
                  key={i}
                  className="fa fa-paw"
                  style={{ color: "#bda697", fontSize: i === 1 ? "1rem" : "0.7rem" }}
                  animate={{ y: [0, -8, 0], opacity: [0.4, 1, 0.4] }}
                  transition={{
                    duration: 1.2,
                    repeat: Infinity,
                    delay: i * 0.2,
                    ease: "easeInOut",
                  }}
                />
              ))}
            </div>

            {/* Message */}
            <motion.div
              animate={{ opacity: [0.6, 1, 0.6] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              className="text-center"
            >
              <p
                className="text-lg font-semibold tracking-wide"
                style={{ color: "#967d6c", fontFamily: "'Poppins', sans-serif" }}
              >
                {message}
              </p>
              <p
                className="text-sm mt-1"
                style={{ color: "#bda697", fontFamily: "'Poppins', sans-serif" }}
              >
                This may take a moment on first load
              </p>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PetLoader;